import {
    PROJECT_SENDING_REQUEST,
    PROJECT_PENDING_DONE,
    PROJECT_LIST_SUCCESS,
    PROJECT_REQUEST_FAIL,
    PROJECT_SINGLE_UPDATE,
    PROJECT_LIST_ADD,
    PROJECT_SINGLE_SUCCESS,
    PROJECT_SINGLE_UPDATE_FROM_ALL,
    TOGGLE_EMAIL_REMINDERS_SUCCESS,
    PROJECT_SEARCH_INPUT,
} from "../action-types/project"

const initProjectList = {
    loading: false,
    message: "",
    successStatus: false,
    projects: [],
    searched: [],
    messagePopup: false,
    redirect: false,
}
export default function projectReducer(state = initProjectList, action) {
    switch (action.type) {

        case PROJECT_SEARCH_INPUT:
            const searched = state.projects.filter((project) => project.projectName.toLowerCase().includes(action.payload.toLowerCase()) || project.productName.toLowerCase().includes(action.payload.toLowerCase()));
            return {
                ...state,
                searched
            }

        case TOGGLE_EMAIL_REMINDERS_SUCCESS:
            const projectToUpdate = state.projects.find(project => project.projectId === action.payload.projectId)
            projectToUpdate.emailReminders = !projectToUpdate.emailReminders;
            return {
                ...state,
            }

        case PROJECT_SENDING_REQUEST:
            return {
                ...state,
                loading: true,
                successStatus: false,
                messagePopup: false,
                redirect: false,
            }
        case PROJECT_PENDING_DONE:
            return {
                ...state,
                messagePopup: false,
                redirect: action.payload?.redirect ?? false,
            }
        case PROJECT_LIST_SUCCESS:
            return {
                loading: false,
                projects: action.payload.projectListGroupByProjectId,
                searched: action.payload.projectListGroupByProjectId,
                successStatus: true,
                message: action.payload.message,
                messagePopup: false,
            }
        case PROJECT_SINGLE_SUCCESS:
            return {
                loading: false,
                projects: [action.payload.project],
                successStatus: true,
                message: action.payload.message,
                messagePopup: false,
            }
        case PROJECT_LIST_ADD:
            return {
                ...state,
                loading: false,
                projects: [action.payload.project, ...state.projects],
                searched: [action.payload.project, ...state.projects],
                successStatus: true,
                message: action.payload.message,
                messagePopup: false,
                redirect: false,
            }
        case PROJECT_SINGLE_UPDATE:
            return {
                loading: false,
                projects: [action.payload.project],
                successStatus: true,
                message: action.payload.message,
                messagePopup: true,
            }
        case PROJECT_REQUEST_FAIL: {
            return {
                ...state,
                loading: false,
                successStatus: false,
                message: action.payload,
                messagePopup: true,
                redirect: false,
            }
        }
        case PROJECT_SINGLE_UPDATE_FROM_ALL: {
            const { projectId } = action.payload
            const { projectUpdate } = action.payload
            const { projectArchive } = projectUpdate
            const updatedProject= state.projects.map(
                (projectItem) =>
                    projectItem.projectId === projectId
                        ? {
                            ...projectItem,
                            projectArchive,
                        }
                        : projectItem
            );

            return {
                ...state,
                loading: false,
                successStatus: true,
                message: action.payload.message,
                messagePopup: true,
                projects: updatedProject,
                searched: updatedProject,
            }
        }
        default:
            return state
    }
}
